import { DateTime } from "luxon";
import { z } from "zod";
import { zPersoneelsdienst } from "@personeel/gen/hey-api/zod.gen";

const PersoneelsdienstDtoSchema = zPersoneelsdienst.strip();

const personeelsdienstOverrides = {
  starttijd: z.iso.datetime({ offset: true }).transform((val) => DateTime.fromISO(val)),
  eindtijd: z.iso.datetime({ offset: true }).transform((val) => DateTime.fromISO(val)),
  // UI-only veld voor layout; komt niet uit de API
  displayRegels: z.number().optional(),
} satisfies z.ZodRawShape;

export const PersoneelsdienstModelSchema = PersoneelsdienstDtoSchema.extend(
  personeelsdienstOverrides,
)
  .transform((val) => ({
    ...val,
    label:
      val.standplaatsDrglptNaam + " " + val.dienstnummer + " - " + val.starttijd?.toFormat("ccc"),
  }))
  .transform((val) => ({
    ...val,
    id: val.standplaatsDrglptNaam + "." + val.dienstnummer + "." + val.starttijd?.toISODate(),
  }));

export const PersoneeldienstModelArraySchema = z.array(PersoneelsdienstModelSchema);

export type PersoneelsdienstModel = z.infer<typeof PersoneelsdienstModelSchema>;
